export const ROUTER_DETAILS = {  
    "VMware edge510": {  
        "size": "Small",  
        "material_number": 908136  
    },  
    "VMware edge510-lte": {  
        "size": "Small",  
        "material_number": 908136  
    },  
    "VMware edge520": {  
        "size": "Small",  
        "material_number": 908136  
    },  
    "VMware edge540": {  
        "size": "Medium",  
        "material_number": 908135  
    },  
    "VMware edge620": {  
        "size": "Medium",  
        "material_number": 908135  
    },  
    "VMware edge680": {  
        "size": "Large",  
        "material_number": 908218  
    },  
    "VMware edge2000": {  
        "size": "unknown",  
        "material_number": "unknown"  
    },  
    "VMware edge3400": {  
        "size": "Xtra Large",  
        "material_number": 908137  
    },  
    "VMware edge3800": {  
        "size": "unknown",  
        "material_number": "unknown"  
    },  
    "VMware edge3810": {  
        "size": "Xtra Large",  
        "material_number": 908137  
    }  
};

// Utility function to get router details
export const getRouterDetails = (routerModel) => {
    return ROUTER_DETAILS[routerModel] || { size: "unknown", material_number: "unknown" };
};